import { render, staticRenderFns } from "./LoadoutDescriptionDialog.vue?vue&type=template&id=0fff94aa&scoped=true&"
import script from "./LoadoutDescriptionDialog.vue?vue&type=script&lang=ts&"
export * from "./LoadoutDescriptionDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fff94aa",
  null
  
)

export default component.exports